import { render } from "./index.vue?vue&type=template&id=89a6ed70&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=89a6ed70&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a6ed70"]])

export default __exports__